import './FlyoutPlaneState.css'
import PropTypes from "prop-types";

import {useSelector} from "react-redux";
import {useContext} from "react";
import {FlyoutPlanContext} from "./flyout-plan-context.js";

import {formatNumber, formatCoordinates, formatTemperature} from "../assets/common/format-utils.js";

FlyoutPlaneState.propTypes = {
    planeId: PropTypes.string
}

export default function FlyoutPlaneState({planeId}) {

    const simState = useSelector(state => state.sim);
    const {plan} = useContext(FlyoutPlanContext);

    const planeState = useSelector(state => state.planes[planeId]);

    const planeReg = planeId || plan.plane.reg;
    const planeType = planeState?.type || plan?.plane.type;
    const planePoB = planeState?.pob || plan?.plane.PoB; // TODO: change to name consistently

    if (!planeState && !plan) {
        return <></>;
    }

    return (
        <div className="flyout-main">
            <div className="flyout-plane-panel">
                <div className="flyout-main-header-plane">
                    <h3 className="flyout-main-plane-reg">{planeReg}</h3>
                    <div className="flyout-main-plane-details">
                        <p>{planeType}</p>
                        <p>{planePoB} PoB</p>
                    </div>
                </div>
                <div className="flyout-plane-parameters">
                    <div className="flyout-plane-parameter">
                        <p className="flyout-plane-parameter-title">Heading</p>
                        <p className="flyout-plane-parameter-value">{formatNumber(planeState?.heading)}°</p>
                    </div>
                    <div className="flyout-plane-parameter">
                        <p className="flyout-plane-parameter-title">Track</p>
                        <p className="flyout-plane-parameter-value">{formatNumber(planeState?.track)}°</p>
                    </div>
                    <div className="flyout-plane-parameter">
                        <p className="flyout-plane-parameter-title">Altitude</p>
                        <p className="flyout-plane-parameter-value">{formatNumber(planeState?.altitude)} ft</p>
                    </div>
                    <div className="flyout-plane-parameter">
                        <p className="flyout-plane-parameter-title">V. Speed</p>
                        <p className="flyout-plane-parameter-value">{formatNumber(planeState?.vs)} fpm</p>
                    </div>
                    <div className="flyout-plane-parameter">
                        <p className="flyout-plane-parameter-title">Power</p>
                        <p className="flyout-plane-parameter-value">{formatNumber(planeState?.power)}%</p>
                    </div>
                    <div className="flyout-plane-parameter">
                        <p className="flyout-plane-parameter-title">Fuel</p>
                        <p className="flyout-plane-parameter-value">{formatNumber(planeState?.fuel,1)} gal</p>
                    </div>
                    <div className="flyout-plane-parameter">
                        <p className="flyout-plane-parameter-title">TAS</p>
                        <p className="flyout-plane-parameter-value">{formatNumber(planeState?.tas)} kts</p>
                    </div>
                    <div className="flyout-plane-parameter">
                        <p className="flyout-plane-parameter-title">GS</p>
                        <p className="flyout-plane-parameter-value">{formatNumber(planeState?.gs)} kts</p>
                    </div>
                    <div className="flyout-plane-parameter">
                        <p className="flyout-plane-parameter-title">OAT</p>
                        <p className="flyout-plane-parameter-value">{formatTemperature(planeState?.temperature)}</p>
                    </div>
                    <div className="flyout-plane-parameter">
                        <p className="flyout-plane-parameter-title">Wind</p>
                        <p className="flyout-plane-parameter-value">
                            {formatNumber(planeState?.wind?.heading)}°/{formatNumber(planeState?.wind?.speed)}kts</p>
                    </div>
                    <div className="flyout-plane-parameter">
                        <p className="flyout-plane-parameter-title">Lat</p>
                        <p className="flyout-plane-parameter-value">
                            {formatCoordinates(planeState?.coordinates?.lat, "NS")}
                        </p>
                    </div>
                    <div className="flyout-plane-parameter">
                        <p className="flyout-plane-parameter-title">Long</p>
                        <p className="flyout-plane-parameter-value">
                            {formatCoordinates(planeState?.coordinates?.long, "EW")}
                        </p>
                    </div>
                </div>
            </div>
            <div className="flyout-main-log" ref={(el) => { if (el) el.scrollTop = el.scrollHeight; }}>
                {simState.planeLog[planeId]?.map((entry, index) => (
                    <div key={index} className="flyout-main-log-entry">
                        <p className="flyout-main-log-entry-time">{entry.time}</p>
                        <p className="flyout-main-log-entry-text">{entry.text}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}